import { FC, FormEvent, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { CardRegistrationForm } from "./CardRegisterForm";

export class CardRegistrationDialogProps {
  clientSecret: string | undefined;
  onClose?: () => void;
}

export const CardRegistrationDialog: FC<CardRegistrationDialogProps> = ({clientSecret, onClose}) => {
  useEffect(() => {
  }, [])

  const stripePromise = loadStripe(process.env.REACT_APP_STROPE_PUBKEY!);
  var options = {
    clientSecret: clientSecret!
  };

  return <>
    <div id="login-dialog" className="dialog-overlay">
      <div className='dialog text-center' style={{ width: "unset" }}>
        <div className="flex justify-end">
          <img onClick={onClose} src="/images/icon-close.svg" className="h-[24px] clickable"/>
        </div>
        <div className="flex justify-end">
          <Elements stripe={stripePromise} options={options}>
            <CardRegistrationForm />
          </Elements>
          </div>
        </div>
    </div>
  </>;

}